import React, { Fragment, useState } from "react";
import PropTypes from "prop-types";
import TableWrapper from "../../shared/bootstrap/TableWrapper";
import { alphabeticalSort } from "../../../util/sort";

/**
 * FedRamp Contract Holders Modal Content
 * @param {Object} props
 * @param {string} props.product
 * @param {ContractHolderGroup[]} props.contractHoldersGroups
 * @param {FedRampContractHolder[]} props.contractHolderData
 * @returns {Element}
 * @constructor
 */
export default function ContractHoldersContent({ product, contractHoldersGroups, contractHolderData }) {
  const [groupFilter, setGroupFilter] = useState("allGroups");

  function filterContractHolderData(group) {
    return contractHolderData.filter(
      ({ group: chGroup }) => chGroup === group && (groupFilter === "allGroups" || groupFilter === chGroup));
  }

  /**
   * @param {React.ChangeEvent<HTMLInputElement>} event
   */
  function handleFilterChange(event) {
    setGroupFilter(event.target.value);
  }

  return (<>
    List of Contract Holders for <strong>{product}</strong>
    <br/>
    <br/>
    <label className="fedramp-chViewRadioContainer">
      All Groups
      <input type="radio" value="allGroups" checked={groupFilter === "allGroups"}
             name="chViewRadioBtn" onChange={handleFilterChange}/>
      <span className="fedramp-radioMark"></span>
    </label>
    {contractHoldersGroups.map(({ group }) => <label key={`${group}-radio`} className="fedramp-chViewRadioContainer">
      {group}
      <input type="radio" value={group} name="chViewRadioBtn" checked={group === groupFilter}
             onChange={handleFilterChange}/>
      <span className="fedramp-radioMark"></span>
    </label>)}
    <TableWrapper id="fedramp-contractholderlist" condensed>
      <thead role="rowgroup">
      <tr role="row">
        <th className="col-xs-5" role="columnheader">Company</th>
        <th className="col-xs-3" role="columnheader">Contract</th>
        <th className="col-xs-5" role="columnheader">Business Designation</th>
      </tr>
      </thead>
      <tbody role="rowgroup">
      {contractHoldersGroups.map(({ group, naicsCode }) => {
        const filteredContractHolderData = filterContractHolderData(group);
        if (filteredContractHolderData.length > 0) {
          return (<Fragment key={group}>
            <tr role="row" className="fedramp-groupheader">
              <td role="columnheader" colSpan="2"><strong>{group}</strong></td>
              <td role="columnheader" colSpan="2" className="text-right"><strong>NAICS Code: {naicsCode}</strong></td>
            </tr>
            {filteredContractHolderData
            .sort((a, b) => alphabeticalSort(a, b, "companyName", "asc"))
            .map(({ chInfoSeq, companyName, displayName, sewpContractNumber, businessSizes }) => (
              <tr key={`${chInfoSeq}-${group}`} className="fedramp-chViewRow">
                <td role="rowheader">
                  <a href={`/sewp5public/contractholders#/detail/${chInfoSeq}`}
                     target="_blank">{companyName} ({displayName})</a>
                </td>
                <td className="text-center" role="gridcell">
                  {sewpContractNumber}
                </td>
                <td className="text-center" role="gridcell">
                  {businessSizes}
                </td>
              </tr>))}
          </Fragment>);
        }
      })}
      </tbody>
    </TableWrapper>
  </>);
}

ContractHoldersContent.propTypes = {
  product: PropTypes.string.isRequired,
  contractHoldersGroups: PropTypes.arrayOf(PropTypes.object).isRequired,
  contractHolderData: PropTypes.arrayOf(PropTypes.object).isRequired,
};